
import React, { useState, useContext, useEffect, useRef } from "react";
import { useNavigate} from "react-router-dom";
import { BillingSummaryContext } from "../contexts/BillingSummaryContext";
import { format } from "date-fns";
import Cookies from 'js-cookie';
import { GetPayLoad } from "../services/PayLoadStorage";
import { getApiService } from "../services/ApiService";
import {Spinner, Form, Modal} from 'react-bootstrap';
import DateRangePickerr from "../components/dateRangePickerr.jsx";
import { toast } from "react-toastify";


const Billinghistory = ({ billingContent, genericContent}) => {

    
    const navigate = useNavigate();
    const { setBillSummaryKeyValue } = useContext(BillingSummaryContext);
    const Payload = GetPayLoad("PayLoad");
    const [billingHistory, setbillingHistory] = useState([]);
    const [allBillingHistory, setAllBillingHistory] = useState([]);
    const [isHistoryLoading, setHistoryLoading] = useState(true);
    const [downloadFormat, setDownloadFormat] = useState("pdf");
    const [billingHistoryErrorFlag, setBillingHistoryErrorFlag] = useState(false);
    const [apiCallsCompleted, setApiCallsCompleted] = useState(false);
    const ref = useRef(null); // Ref for the <main> tag
    const [isContentReady, setContentReady] = useState(false);
    const showSTPS = Cookies.get('showSTPS') !== 'false';
    const showSTPS2 = Cookies.get('showSTPS2') !== 'false';
    /* PMO0004087 CHG0127827 SD47534 */
    const showSTPS3 = Cookies.get('showSTPS3') !== 'false';
    const showAPTC = Cookies.get('showAPTC') !== 'false';

    const getButtonClassName = () => {
    switch (Payload?.owning_carrier) {
        case 'CG':
            return 'btn-outline-primary';
        case 'Q5':
            return 'btn-outline-secondary';
        case 'X6':
            return 'btn-primary';
        default:
            return 'btn-outline-primary';
    }
};
    
    const baseUrl = process.env.REACT_APP_API_BASE_URL;
    const headers = {
        "X-Hps-Client-Id": process.env.REACT_APP_API_CLIENT_ID,
        "X-Hps-Secret-Id": process.env.REACT_APP_API_SECRET_ID,
        "X-Hps-Region": Payload?.region,
        "X-Hps-Carrier": Payload?.owning_carrier,
    };
    
    // Fetch Billing History Data
    useEffect(() => {
        const targetUrl = process.env.REACT_APP_API_BILLING_HISTORY_ENDPOINT;
        getApiService(
            baseUrl,
            targetUrl,
            { cim: Payload?.cim, case_num: Payload?.case_num },
            headers
            )
            .then((response) => {
            setHistoryLoading(false);
            if (response?.data?.statusCode !== 200) {
                setBillingHistoryErrorFlag(true);
            } else {
                const result = response.data.data;
                setBillingHistoryErrorFlag(false);
                setbillingHistory(result);
                setAllBillingHistory(result);
                setApiCallsCompleted(true);
            }
            })
            .catch((error) => {
            setHistoryLoading(false);
            setBillingHistoryErrorFlag(true);
            });
    }, []);
    

    // Billing Details Click
    const handleBillingDetailsClick = (e, item) => {
        e.preventDefault();
        setBillSummaryKeyValue(item);
        navigate("/billing-summary");
    };

    const billhistorycolumns = [

        billingContent?.billing_billing_history_bill_period_text,
        billingContent?.billing_billing_history_prior_balance_text,
        billingContent?.billing_billing_history_bill_amount_text,
        billingContent?.billing_billing_history_adjustments_text,
        billingContent?.billing_billing_history_payment_received_text,
        billingContent?.billing_billing_history_fee_text,
        billingContent?.billing_billing_history_amount_due_text,
      ]; 

            if (showSTPS) {
        billhistorycolumns.push(billingContent?.billing_billing_history_stps1_text);
      }
    
            if (showSTPS2) {
        billhistorycolumns.push(billingContent?.billing_billing_history_stps2_text);
      }

            if (showSTPS3) { /* PMO0004087 CHG0127827 SD47534*/
                billhistorycolumns.push(billingContent?.billing_billing_history_stps3_text || 'STPS3');
            }

            if (showAPTC) {
        billhistorycolumns.push(billingContent?.billing_billing_history_aptc_amount_text);
      }   
      

    // Handle Date Filter Apply
    const handleApplyDateFilter = (filterType, dateRange) => {
        const { startDate, endDate } = dateRange;
        // Billing History
        const filtered = allBillingHistory.filter((record) => {
        const billDate = new Date(record.bill_per_beg_dt);
        return billDate >= startDate && billDate <= endDate;
        });
        setbillingHistory(filtered);
        
    };

    // Handle Download PDF/Excel
    const handelDownloadPDF = () => {
        if (billingHistory?.length > 0) {
          const downloadFormat = document.querySelector(
            'input[name="bhdownloadFormat"]:checked'
          ).value;
          const displayFlag = 1;
          const displayName = '';
          const targetCaseUrl =
            baseUrl + process.env.REACT_APP_API_PDF_EXCEL_DOWNLOAD_ENDPOINT;
          const currentLang = Cookies.get("lang") || "eng";
    
          // Create a form element
          const form = document.createElement("form");
          form.method = "POST";
          form.action = targetCaseUrl;
          form.target = "_blank"; // Open in a new tab or window
    
          // Add form fields
          const fields = {
            cim: Payload?.cim,
            region: Payload?.region,
            case_num: Payload?.case_num,
            owningCarrier: Payload?.owning_carrier,
            downloadFormat: downloadFormat,
            language: currentLang,
            columns: JSON.stringify(billhistorycolumns),
            rows: JSON.stringify(billingHistory),
            sitecd: Payload?.site_cd,
            displayFlag: displayFlag,
            displayName: Payload?.displayName,
            isSTPSAvailable: showSTPS,
            isSTPS2Available: showSTPS2,
            isSTPS3Available: showSTPS3, /* PMO0004087 CHG0127827 SD47534*/
            isAPTCAvailable: showAPTC,
            state: Payload?.state || null,
            pageName: "billinghistory",
            "X-Hps-Client-Id": process.env.REACT_APP_API_CLIENT_ID,
            "X-Hps-Secret-Id": process.env.REACT_APP_API_SECRET_ID,
            "X-Hps-Region": Payload?.region,
            "X-Hps-Carrier": Payload?.owning_carrier,
          };
    
          for (const key in fields) {
            if (fields[key] !== undefined) {
              const input = document.createElement("input");
              input.type = "hidden";
              input.name = key;
              input.value = fields[key];
              form.appendChild(input);
            }
          }
    
          // Append the form to the body, submit it, and remove it
          document.body.appendChild(form);
          form.submit();
          if (downloadFormat === "excel") {
            const message =
              genericContent?.excel_download_sucess ||
              "Excel Downloaded Successfully";
            toast.success(message);
          }
          document.body.removeChild(form);
        } else {
          const message =
            billingContent?.billing_payment_auth_nodata_text ||
            "No billing history available for download.";
          toast.error(message);
        }
    };

    // Accessibility: Focus Management
    const [userInteracted, setUserInteracted] = useState(false);
        
    useEffect(() => {
        const handleUserInteraction = () => {
        setUserInteracted(true);
        };
    
        // Listen for user interactions
        document.addEventListener('click', handleUserInteraction);
        document.addEventListener('keydown', handleUserInteraction);
        
        return () => {
        document.removeEventListener('click', handleUserInteraction);
        document.removeEventListener('keydown', handleUserInteraction);
        };
    }, []);
        
    useEffect(() => {
        let timeoutId;
        
        if (apiCallsCompleted && !isContentReady) {
            timeoutId = setTimeout(() => {
                setContentReady(true);
                
                // Only auto-focus if user hasn't interacted
                if (!userInteracted && ref.current) {
                requestAnimationFrame(() => {
                    ref.current.focus({ preventScroll: true });
                });
                }
            }, parseInt(process.env.REACT_APP_READABILITY_TIMEOUT));
        }
        
        return () => {
            if (timeoutId) clearTimeout(timeoutId);
        };
    }, [apiCallsCompleted, isContentReady, userInteracted]);
    

    return (
    <>
        <main role="main"
            tabIndex="-1" // Make the <main> tag focusable
            ref={ref} // Attach the ref to the <main> tag
            aria-label="Billing History"
            aria-live="polite"
            style={{ outline: 'none' }} // revmove border
            >   
            
            <Modal.Header className={`billing-header d-xl-flex d-md-flex ${Payload?.owning_carrier === 'Q5' ? 'mobile-close-btn' : ''}`} closeButton>
                <div className="d-xl-flex d-md-flex pb-3" style={{ width: "100%" }} id="billing-history-title">
                    <Modal.Title className="col-xl-3 col-md-3 mt-xl-margin ps-2" tabIndex={0}>
                                                {Payload?.owning_carrier === 'Q5' ? (
                                                    <h3 className="q5-billing-history-title">{billingContent?.billing_billing_history_title}</h3>
                                                ) : (
                                                    <h5>{billingContent?.billing_billing_history_title}</h5>
                                                )}
                    </Modal.Title>
                    {!isHistoryLoading && !billingHistoryErrorFlag && billingHistory && (
                        <div className="col-xl-9 col-md-9 d-flex float-sm-start billing-history-controls-wrapper">
                            <DateRangePickerr onApplyDateFilter={handleApplyDateFilter} carrier={Payload?.owning_carrier} />
                            
                            <div className="d-flex align-items-center flex-nowrap billing-history-button-group">
                                {billingHistory?.length > 0 && (
                            <div className="d-flex align-items-center ms-md-2 billing-history-radio-wrapper">
                                <Form.Check
                                inline
                                label="PDF"
                                name="bhdownloadFormat"
                                type="radio"
                                id="pdf-radio"
                                value="pdf"
                                aria-label="Select PDF download format"
                                defaultChecked
                                className="payment-download-radio"
                                onChange={(e) => setDownloadFormat(e.target.value)}
                                />
                                <Form.Check
                                inline
                                label="Excel"
                                name="bhdownloadFormat"
                                type="radio"
                                id="excel-radio"
                                value="excel"
                                aria-label="Select Excel download format"
                                className="payment-download-radio"
                                onChange={(e) => setDownloadFormat(e.target.value)}
                                />
                            </div>
                            )}
                            {billingHistory?.length > 0 && (
                            <button
                                className={`btn ${Payload?.owning_carrier === 'Q5' ? 'btn-outline-secondary' : 'btn-primary'} rounded ms-1 billing-history-download-btn`}
                                onClick={() => handelDownloadPDF()}
                                aria-label={billingContent?.billing_billing_history_export_pdf_hint}
                            >
                                {billingContent?.billing_billing_history_export_pdf_hint}{" "}
                                {Payload?.owning_carrier !== 'Q5' && (
                                    <i className="fe fe-download fe-12"></i>
                                )}
                            </button>
                            )}
                            </div>
                        </div>
                       
                    )}
                </div>
            </Modal.Header>

            <Modal.Body className="billing-history-modal-body">
                <div className="" id="billing-history-description">  
                
                {billingHistoryErrorFlag && (
                    <div className="api-error-msg" role="alert" aria-live="assertive">
                    {genericContent?.finance_service_error}
                    </div>
                )}

                {isHistoryLoading && (
                    <div style={{ display: "flex", alignItems: "center", gap: "15px", margin: "inherit" }}>
                        <Spinner animation="border" role="status" aria-live="assertive"></Spinner>
                        <div style={{ fontSize: "12px" }}>
                            {genericContent?.loading_message}
                        </div>
                    </div>
                )}

                {!isHistoryLoading && !billingHistoryErrorFlag && billingHistory && (
                    <div className="bd-example table-responsive billing-tables d-grid-tbl mb-4" tabIndex={0}>
                        <div className="d-flex px-2">
                            <div className="col-12 mb-2 nav-billings">
                            <h6>
                                {billingHistory?.length}{" "}
                                {billingContent?.billing_transaction_text}
                                {billingHistory?.length > 1 ? "(s)" : ""}{" "}
                                {billingContent?.billing_found_text}
                            </h6>
                            </div>
                        </div>
                       
                        <table className="table table-striped">
                            <thead className="sticky-top">
                                <tr>
                                {billhistorycolumns.map((column, index) => (
                                    <th scope="col" key={index}>
                                        <span className="visually-hidden">row 1 column  {index+1} </span> 
                                        {column}
                                    </th>
                                ))}
                                <th scope="col" aria-label="Actions"></th>
                                </tr>
                            </thead>
                            <tbody>
                                {billingHistory?.length === 0 ? (
                                <tr>
                                    <td colSpan={11} className="fw-semibold" aria-live="polite">
                                    <div className="d-flex px-2">
                                        <div className="col-12 mb-2">
                                        <h6>{billingContent?.billing_billing_history_no_data_text}</h6>
                                        </div>
                                    </div>
                                    </td>
                                </tr>
                                ) : (
                                billingHistory.map((item, index) => (
                                    <tr key={index} className="border-bottom">
                                    <td className="">
                                        <span className="visually-hidden">row {index + 2} column 1 {billingContent?.billing_billing_history_bill_period_text}: </span>
                                        {item?.bill_per_beg_dt_format}
                                    </td>
                                    <td>
                                        <span className="visually-hidden"> column 2 {billingContent?.billing_billing_history_prior_balance_text}: </span>
                                        {item?.bill_prior_balance}
                                    </td>
                                    <td>
                                        <span className="visually-hidden"> column 3 {billingContent?.billing_billing_history_bill_amount_text}: </span>
                                        {item?.total_current_charges}
                                    </td>
                                    <td>
                                        <span className="visually-hidden"> column 4 {billingContent?.billing_billing_history_adjustments_text}: </span>
                                        {item?.total_adjustments}
                                    </td>
                                    <td>
                                        <span className="visually-hidden"> column 5 {billingContent?.billing_billing_history_payment_received_text}: </span>
                                        {item?.total_premium_collected}
                                    </td>
                                    <td>
                                        <span className="visually-hidden"> column 6 {billingContent?.billing_billing_history_fee_text}: </span>
                                        {item?.current_fees}
                                    </td>
                                    <td>
                                        <span className="visually-hidden"> column 7 {billingContent?.billing_billing_history_amount_due_text}: </span>
                                        {item?.bill_total_amount_due}
                                    </td>
                                    {showSTPS && (
                                        <td>
                                            <span className="visually-hidden"> column 8 {billingContent?.billing_billing_history_stps1_text}: </span>
                                            {item?.state_subsidy_premium}
                                        </td>
                                    )}
                                    {showSTPS2 && (
                                        <td>
                                            <span className="visually-hidden"> column {8 + Number(showSTPS)} {billingContent?.billing_billing_history_stps2_text}: </span>
                                            {item?.state_subsidy2_premium}
                                        </td>
                                    )}
                                    {showSTPS3 && ( /* PMO0004087 CHG0127827 SD47534*/
                                        <td>
                                            <span className="visually-hidden"> column {8 + Number(showSTPS) + Number(showSTPS2)} {billingContent?.billing_billing_history_stps3_text || 'STPS3'}: </span>
                                            {item?.state_subsidy3_premium}
                                        </td>
                                    )}
                                    {showAPTC && (
                                        <td>
                                            <span className="visually-hidden"> column {8 + Number(showSTPS) + Number(showSTPS2) + Number(showSTPS3)} {billingContent?.billing_billing_history_aptc_amount_text}: </span>
                                            {item?.subsidy_premium}
                                        </td>
                                    )}
                                    <td>
                                        <button
                                            type="button"
                                            className={`btn ${getButtonClassName()} rounded`}
                                            onClick={(e) => handleBillingDetailsClick(e, item)}
                                            aria-label={`${billingContent?.billing_billing_history_billing_details_btn_text || 'Billing Details'} for bill period ${item?.bill_per_beg_dt_format}`}
                                        >
                                            {billingContent?.billing_billing_history_billing_details_btn_text || 'Billing Details'}
                                        </button>
                                    </td>
                                    </tr>
                                ))
                                )}
                            </tbody>
                        </table>
                    </div>
                )}
                </div>
            </Modal.Body>
        </main>
    </>
    );
};

export default Billinghistory;